import { BaseListComponent } from './base-list-component';
import { IBaseService } from '../service/ibase-service';
import { PaginationData } from '../modal/pagination-data';
import { OrderingData } from '../modal/ordering-data';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ResponseCode } from '../constant/response-code';
import { VALIDATION_CONFIGURATION } from 'src/environments/configuration';
import { LocalDataSource } from 'ng2-smart-table';
import { RouteInfo } from '../../shared/sidebar/sidebar.metadata';
import { environment } from '../../../environments/environment';
import { AclDataModal } from '../../shared/sidebar/acl-data-modal';
import { getServers } from 'dns';
import { Row } from 'ng2-smart-table/lib/data-set/row';
import { UserModal } from '../../modules/user/modal/user-modal';
import { DatePipe } from '@angular/common';
import { SearchData } from '../modal/search-data';

export abstract class AbstractBaseListComponent<T> implements BaseListComponent<T> {
  public orderingData: OrderingData;
  public totalRecords: number;
  public paginatioData: PaginationData;
  public validationConfiguration = VALIDATION_CONFIGURATION;
  public smartTablesettings: any;
  public smartTablesettingsWithSearch: any;
  public source: LocalDataSource;
  //public selectedColumns : Array<{title : string,id:string,isSelected : boolean}>;
  public isAdvancedSearchEnable: boolean = false;

  public isDeleteAllow: boolean = true;
  public isEditAllow: boolean = true;
  public isViewAllow: boolean = true;
  public isAddAllow: boolean = true;

  public activeUser: UserModal;
  public isUserAllow: boolean;
  public searchData = new SearchData();

  public sortDate = (direction: any, a: string, b: string) => {
    let firstDate, secondDate;
    const firstDateParts = a ? a.split('-') : '';
    const secondDateParts = b ? b.split('-') : '';
    if (firstDateParts && firstDateParts.length !== 0) {
      firstDate = new Date(+firstDateParts[2], +firstDateParts[1] - 1, +firstDateParts[0]);
    }
    if (secondDateParts && secondDateParts.length !== 0) {
      secondDate = new Date(+secondDateParts[2], +secondDateParts[1] - 1, +secondDateParts[0]);
    }
    const first = Number(new DatePipe('en-EN').transform(firstDate, 'yyyyMMdd'));
    const second = Number(new DatePipe('en-EN').transform(secondDate, 'yyyyMMdd'));

    if (first < second) {
      return -1 * direction;
    }
    if (first > second) {
      return direction;
    }
    return 0;
  };

  constructor(private toastr: ToastrService, private routerSrv: Router) {}
  abstract getService(): IBaseService<T>;
  abstract setList(Array);
  abstract getTableColumn(): any;

  init() {
    this.initAcl();
    this.initSmartColumns();
    if (!this.orderingData) {
      this.orderingData = new OrderingData();
      this.orderingData.column = 'id';
      this.orderingData.descending = false;
    }

    this.paginatioData = new PaginationData();
    this.getList(this.paginatioData, this.orderingData);
    this.authRole();
  }

  setPaginationPerPage(pageNumber) {
    if (pageNumber) {
      this.paginatioData.rowsPerPage = pageNumber;
    }
  }

  getGridSettingInfo(fetch_setting_data) {
    let paginationData = fetch_setting_data ? fetch_setting_data.page : null;
    let orderingData = fetch_setting_data ? fetch_setting_data.order : null;
    let searchData =
      fetch_setting_data && fetch_setting_data.search && fetch_setting_data.search.length > 0
        ? JSON.stringify(fetch_setting_data.search)
        : null;
    let params: any = {};
    if (paginationData) {
      params.page = paginationData.pageNumber.toString();
      params.pageSize = paginationData.rowsPerPage.toString();
    }
    if (orderingData) {
      params.sortBy = orderingData.active;
      params.sortOrder = (orderingData.direction  ? 1 : 0) + '';
    }
    if (searchData) {
      let sData = JSON.parse(searchData);
      sData.forEach((element) => {
        let temp = element.filterValue;
        if(temp)
        element.filterValue = temp[element.filterColumn];
      });
      params.filters = JSON.parse(searchData);
    }
    return params;
  }

  initV2() {
    this.initAcl();
    this.initSmartColumns();
    if (!this.orderingData) {
      this.orderingData = new OrderingData();
      this.orderingData.column = 'id';
      this.orderingData.descending = false;
    }

    this.paginatioData = new PaginationData();
    this.getListV2(this.paginatioData, this.orderingData);
    this.authRole();
  }

  delete(modal: T) {
    this.getService()
      .delete(modal)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          this.onDeleteSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  deleteV2(modal: T) {
    this.getService()
      .deleteV2(modal)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          this.onDeleteSuccess();
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  getList(paginationData: PaginationData, orderingData: OrderingData) {
    if (paginationData.pageNumber <= 0) {
      paginationData.pageNumber = 1;
    }
    this.getService()
      .getAll(paginationData, orderingData)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          this.totalRecords = response.totalRecords;
          this.setList(response.dataList);
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  getListV2(paginationData: PaginationData, orderingData: OrderingData) {
    if (paginationData.pageNumber <= 0) {
      paginationData.pageNumber = 1;
    }
    this.getService()
      .getAllV2(paginationData, orderingData)
      .subscribe(
        (response) => {
          if (response.responseCode != ResponseCode.OK) {
            this.onResponseError(response.responseMessage);
            return;
          }
          this.totalRecords = response.totalRecords;
          this.setList(response.dataList);
        },
        (error) => {
          this.onResponseError(error.message);
        }
      );
  }

  public onDeleteSuccess() {
    this.toastr.success('Data has been deleted successfully.', 'Success');
    this.onDeleteSuccessed();
  }

  public onDeleteSuccessed() {
    this.getList(this.paginatioData, this.orderingData);
  }

  public onResponseError(message: string) {
    this.toastr.error(message, 'Error');
  }

  onPaginationChange(paginationData: PaginationData) {
    this.paginatioData = paginationData;
    this.getList(paginationData, this.orderingData);
  }

  private initAcl() {
    try {
      this.isDeleteAllow = !this.hideDeleteButton();
      let aclModule: Map<string, AclDataModal> = new Map<string, AclDataModal>();
      let aclDataString = localStorage.getItem(environment.ACL_LOCAL_KEY);
      if (aclDataString) {
        aclModule = new Map(JSON.parse(aclDataString));
        let serviceName: string = this.getService().getModuleName();
        let acl: AclDataModal = aclModule.get(serviceName);

        if (acl) {
          this.isAddAllow = acl.create == 1;
          this.isDeleteAllow = acl.delete == 1 && !this.hideDeleteButton();
          this.isEditAllow = acl.update == 1;
          this.isViewAllow = acl.view == 1;
        }
      }
    } catch (e) {
      console.error('Error in initAcl', e);
    }
  }
  private initSmartColumns() {
    this.smartTablesettings = {
      attr: {
        class: 'table-responsive',
      },
      mode: 'external',
      edit: {
        editButtonContent: '<i class="ti-pencil text-info m-r-10"></i>',
      },
      delete: {
        deleteButtonContent: '<i class="ti-trash text-danger m-r-10"></i>',
      },
      actions: {
        add: false,
        edit: this.isEditAllow,
        delete: this.isDeleteAllow,
      },
      hideSubHeader: true,
      columns: {},
    };

    this.smartTablesettings.columns = this.getTableColumn();

    this.smartTablesettingsWithSearch = Object.assign({}, this.smartTablesettings);
    this.smartTablesettingsWithSearch.hideSubHeader = false;
    let columnList = this.getTableColumn();
    let keys: string[] = Object.keys(columnList);
    keys.forEach((value, index) => {
      this.smartTablesettingsWithSearch.columns[value].filter = true;
    });
  }

  onSearch(query: string = '') {
    if (!this.source) {
      return;
    }

    if (!query) {
      this.source.setFilter([]);
      return;
    }
    let filter: Array<{ field: string; search: string }> = new Array<{ field: string; search: string }>();

    let keys: string[] = Object.keys(this.getTableColumn());

    keys.forEach((keyName) => {
      filter.push({ field: keyName, search: query });
    });
    this.source.setFilter(filter, false);
  }

  public onAdvanceSearchClick() {
    this.isAdvancedSearchEnable = !this.isAdvancedSearchEnable;
  }

  public hideDeleteButton(): boolean {
    return false;
  }

  onSmartTableEditClick(eventData: Row) {
    this.onEditClick(eventData.getData());
  }

  onSmartTableDeleteClick(eventData: Row) {
    this.onDeleteClick(eventData.getData());
  }

  public abstract onDeleteClick(data: T);
  public abstract onEditClick(data: T);

  // Created To Fix PDF, Excels Data Issues
  refreshLocalData() {
    setTimeout(() => {
      this.getList(this.paginatioData, this.orderingData);
    }, 1500);
  }

  public authRole() {
    // Id 1 for admin, Id 2 for staff, Id 3 for SuperAdmin, Id 4 for other.
    this.activeUser = JSON.parse(localStorage.getItem('activeUser'));
    if (this.activeUser && this.activeUser.role && this.activeUser.role.roleid) {
      if (this.activeUser.role.roleid === 1 || this.activeUser.role.roleid === 3) {
        this.isUserAllow = true;
      }
      if (this.activeUser.role.roleid === 2 || this.activeUser.role.roleid === 4) {
        this.isUserAllow = false;
      }
    }
  }

  setOrderingData(orderingData: OrderingData = null) {
    if (!orderingData) {
      this.orderingData = new OrderingData();
      this.orderingData.column = 'id';
      this.orderingData.descending = false;
    }
  }
}
